import Alertify from '@/plugin/alertify'
import App from '@/pages/App'
import Http from '@/plugin/resource'
import ProgressBar from '@/plugin/progress-bar'
import RouterFactory from '@/pages/router-factory'
import Routes from './routes'
import StoreFactory from '@/pages/store-factory'
import Stores from './stores'
import Vue from 'vue'

import '@/styles/global.scss'

const Router = RouterFactory.create(Routes)
const Store  = StoreFactory.create(Stores)

Vue.use(Alertify);
Vue.use(Http);
Vue.use(ProgressBar);

new Vue({
  http   : Http,
  router : Router,
  store  : Store,
  render : h => h(App),
}).$mount('#vue-app-container')
